import React, { ChangeEvent, useContext, useState } from 'react';
import { AppContext } from '../../../../common/context/';
import { BaseConfirmModal } from '../../modals/BaseConfirmModal';
import { Props } from './selectGroupsAreasProps';

const SelectGroupsAreas = ({ isOpenModal, onClose, onSubmit }: Props) => {
    const { langResources, areasList, groupList } = useContext(AppContext);

    const [groupIds, setGroupIds] = useState<number[]>(
        areasList.map((area) => area.id)
    );
    const [areaIds, setAreaIds] = useState<number[]>(
        groupList.map((group) => group.id)
    );

    const hanlderChangeArea = ({ target }: ChangeEvent<HTMLSelectElement>) => {
        const areaId = Number(target.value);

        if (areaId == -1) {
            setAreaIds(areasList.map((area) => area.id));
        } else {
            console.log(areaId);
            setAreaIds([areaId]);
        }
    };

    const hanlderChangeGroups = ({ target }: ChangeEvent<HTMLSelectElement>) => {
        const groupId = Number(target.value);

        if (groupId == -1) {
            setAreaIds(groupList.map((group) => group.id));
        } else {
            console.log(groupId);
            setGroupIds([groupId]);
        }
    };

    const handlerSubmit = () => {
        onSubmit(areaIds, groupIds);
        onClose();
    };

    return (
        <BaseConfirmModal
            isLoading={false}
            isOpen={isOpenModal}
            isShowControls={true}
            modalTitle={langResources['filter.modal.select.groups.areas.title']}
            onClose={onClose}
            onSubmit={handlerSubmit}
            textButton={langResources['reports.generate.report.button']}
        >
            <div className='modal-body'>
                <div className='d-flex flex-column gap-4'>
                    <div>
                        <label htmlFor='multipleSelectArea'>
                            {
                                langResources[
                                    'filter.modal.select.groups.areas.select.areas.label'
                                ]
                            }
                            :
                        </label>
                        <select
                            multiple={false}
                            className='form-select text-dark'
                            aria-label='multiple select example'
                            id='multipleSelectArea'
                            onChange={(e) => hanlderChangeArea(e)}
                        >
                            <option value={-1} selected>
                                {
                                    langResources[
                                        'filter.modal.select.groups.areas.default.option.label'
                                    ]
                                }
                            </option>
                            {areasList.map((area) => (
                                <option value={area.id}>{area.name}</option>
                            ))}
                        </select>
                    </div>

                    <div>
                        <label htmlFor='multipleSelectGroup'>
                            {
                                langResources[
                                    'filter.modal.select.groups.areas.select.groups.label'
                                ]
                            }
                            :
                        </label>
                        <select
                            multiple={false}
                            className='form-select text-dark'
                            aria-label='multiple select example'
                            id='multipleSelectGroup'
                            onChange={(e) => hanlderChangeGroups(e)}
                        >
                            <option value={-1} selected>
                                {
                                    langResources[
                                        'filter.modal.select.groups.areas.default.option.label'
                                    ]
                                }
                            </option>
                            {groupList.map((group) => (
                                <option value={group.id}>{group.name}</option>
                            ))}
                        </select>
                    </div>
                </div>
            </div>
        </BaseConfirmModal>
    );
};

export default SelectGroupsAreas;
